// extracted by mini-css-extract-plugin
export default {"flex_container":"FlexContainer_flex_container__p0Rex"};